const BASE_URL = process.env.REACT_APP_ADMIN_BASE_URL; // "https://admin-api.boxknight.com";

const request = (options) => {
  let headers = {
    "Content-Type": "application/json",
  };

  addHeaderIfLocal(headers);
  if (options.queryParams) {
    options.url += (options.url.indexOf("?") === -1 ? "?" : "&") + queryParams(options.queryParams);
    delete options.queryParams;
  }

  if (localStorage.getItem("token")) {
    options.headers.Authorization = localStorage.getItem("token");
  }
  const defaults = { headers: headers };
  options = Object.assign({}, defaults, options);
  return fetch(options.url, options).then((response) => {
    if (response.headers.get("content-type").indexOf("application/pdf") > -1) {
      return response.text();
    }
    return response.json().then((json) => {
      if (!response.ok) {
        return Promise.reject(json);
      }
      return json;
    });
  });
};

const fileRequest = (options) => {
  let headers = {
    "Content-Type": "application/json",
  };

  addHeaderIfLocal(headers);

  if (options.queryParams) {
    options.url += (options.url.indexOf("?") === -1 ? "?" : "&") + queryParams(options.queryParams);
    delete options.queryParams;
  }

  if (localStorage.getItem("token")) {
    headers.Authorization = localStorage.getItem("token");
  }
  const defaults = { headers: headers };
  options = Object.assign({}, defaults, options);
  return fetch(options.url, options).then((response) => {
    if (!response.ok) {
      return Promise.reject(response.arrayBuffer());
    }
    return response.arrayBuffer();
  });
};

const queryParams = (params) => {
  return Object.keys(params)
    .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
    .join("&");
};

export function login(loginData) {
  return request({
    url: `${BASE_URL}/user/login`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(loginData),
  });
}

export function register(registerData) {
  return request({
    url: `${BASE_URL}/user/register`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(registerData),
  });
}

export function getMerchants(offset, limit) {
  return request({
    url: `${BASE_URL}/merchants?offset=${offset}&limit=${limit}`,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getMerchantsNameSearch(name) {
  return request({
    url: `${BASE_URL}/merchants/nameSearch?name=${name}`,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getMerchantNames() {
  return request({
    url: `${BASE_URL}/merchants/names`,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function addZone(zoneData, merchantId) {
  return request({
    url: `${BASE_URL}/merchants/${merchantId}/zones`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(zoneData),
  });
}

export function editZone(zoneData, merchantId, operation) {
  return request({
    url: `${BASE_URL}/merchants/${merchantId}/zones/${operation}`,
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(zoneData),
  });
}

export function deleteZone(merchantId, zoneName) {
  return request({
    url: `${BASE_URL}/merchants/${merchantId}/zones?zoneName=${zoneName}`,
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getMerchantById(merchantId) {
  return request({
    url: `${BASE_URL}/merchants/${merchantId}`,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getAllShippingRules(merchantId) {
  return request({
    url: `${BASE_URL}/merchants/${merchantId}/shippingRules`,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function addShppingRule(data, merchantId) {
  return request({
    url: `${BASE_URL}/merchants/${merchantId}/shippingRules`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
}

export function deleteShippingRule(merchantId, originZone, destinationZone) {
  return request({
    url: `${BASE_URL}/merchants/${merchantId}/shippingRules?originZone=${originZone}&destinationZone=${destinationZone}`,
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function editShippingRule(data, merchantId, operation) {
  return request({
    url: `${BASE_URL}/merchants/${merchantId}/shippingRules/${operation}`,
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
}

export function getRates(merchantId, data) {
  return request({
    url: `${BASE_URL}/rates/${merchantId}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
}

export function getWindows(merchantId, myDateTime, postalCode, originPostalCode) {
  return request({
    url: `${BASE_URL}/rates/windows/${merchantId}?dateTime=${myDateTime}&postalCode=${postalCode}&originPostalCode=${originPostalCode}`,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getOrderById(id) {
  return request({
    url: `${BASE_URL}/orders/getOrders/${id}`,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getUsers() {
  return request({
    url: `${BASE_URL}/user/manageUsers`,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function deleteUser(email) {
  return request({
    url: `${BASE_URL}/user/manageUsers/${email}`,
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function createUser(body) {
  return request({
    url: `${BASE_URL}/user/manageUsers`,
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
}

export function createServiceUser(merchantId) {
  return request({
    url: `${BASE_URL}/merchants/${merchantId}/user`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ group: "service" }),
  });
}

export function editUser(body) {
  return request({
    url: `${BASE_URL}/user/manageUsers`,
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
}

export function updateOrder(orderId, body) {
  return request({
    url: `${BASE_URL}/orders/updateOrder/${orderId}`,
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
}

export function updateAddress(orderId, body, addressToEdit) {
  return request({
    url: `${BASE_URL}/orders/${addressToEdit}/${orderId}`,
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
}

export function getLabelByOrderId(orderId) {
  return request({
    url: `${BASE_URL}/labels/${orderId}`,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function searchOrders(filters) {
  const body = {};
  if (filters.id != null && filters.id.length > 0) {
    body.id = filters.id;
  }
  if (filters.refNumber != null && filters.refNumber.length > 0) {
    body.refNumber = filters.refNumber;
  }
  if (filters.merchantId != null && filters.merchantId.length > 0) {
    body.merchantId = filters.merchantId;
  }
  if (filters.orderStatus != null && filters.orderStatus.length > 0) {
    body.orderStatus = filters.orderStatus;
  }
  if (filters.deliveryType != null && filters.deliveryType.length > 0) {
    body.deliveryType = filters.deliveryType;
  }
  if (filters.createdAtStart != null) {
    body.createdAtStart = filters.createdAtStart;
  }
  if (filters.createdAtEnd != null) {
    body.createdAtEnd = filters.createdAtEnd;
  }
  if (filters.completeAfter != null) {
    body.completeAfter = filters.completeAfter;
  }
  if (filters.completeBefore != null) {
    body.completeBefore = filters.completeBefore;
  }
  if (filters.lastEvaluatedKey != null) {
    body.lastEvaluatedKey = filters.lastEvaluatedKey;
  }
  if (filters.createdAt != null) {
    body.createdAt = filters.createdAt;
  }
  if (filters.limit != null) {
    body.limit = filters.limit;
  }

  return request({
    url: `${BASE_URL}/orders`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
}

export function editMerchant(merchantData, id) {
  return request({
    url: `${BASE_URL}/merchants/${id}`,
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(merchantData),
  });
}

export function addMerchantGoboltOrgId(id) {
  return request({
    url: `${BASE_URL}/merchants/${id}/gobolt/organization`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });
}

export function addMerchantGoboltPickupCustomerId(id) {
  return request({
    url: `${BASE_URL}/merchants/${id}/gobolt/pickupCustomer`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });
}

export function reviveOrder(orderId) {
  return request({
    url: `${BASE_URL}/orders/${orderId}/revive`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

// used for testing locally
const addHeaderIfLocal = (headers) => {
  if (BASE_URL.includes("localhost") && process.env.REACT_APP_LOCAL_MERCHANT_ID) {
    headers["x-aws-sqsd-attr-merchant-id"] = process.env.REACT_APP_LOCAL_MERCHANT_ID;
  }
};

export function retryGoboltOrderCreation(orderId) {
  return request({
    url: `${BASE_URL}/orders/retry/${orderId}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function bulkUpdateOrdersByOperation(operation, body) {
  return request({
    url: `${BASE_URL}/orders/admin/bulk/${operation}`,
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
}

export function archiveMerchantById(merchantId) {
  return request({
    url: `${BASE_URL}/merchants/${merchantId}/archive`,
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function addMerchant(merchantData) {
  return request({
    url: `${BASE_URL}/merchants/create`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(merchantData),
  });
}

export function getUsersByMerchantId(merchantId) {
  return request({
    url: `${BASE_URL}/merchants/${merchantId}/users`,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function deleteUserByUsername(merchantId, username) {
  return request({
    url: `${BASE_URL}/merchants/${merchantId}/users/${username}`,
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function editUserByUsername(username, body) {
  return request({
    url: `${BASE_URL}/user/${username}`,
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
}

export function createMerchantUser(merchantId, body) {
  return request({
    url: `${BASE_URL}/merchants/${merchantId}/user`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...body, group: "merchant_admin" }),
  });
}

export function getUserByUsername(username) {
  return request({
    url: `${BASE_URL}/user/${username}`,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getFeatureFlag(name) {
  return request({
    url: `${BASE_URL}/orders/admin/featureFlags/${name}`,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}
